
import Vue from 'vue';
import { Component, Prop, Watch} from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from "moment";
const notification = namespace("notification");
const profile = namespace("profile");
// import { bus } from "../../main";
import bus from '../../eventBus';
import { useAppInsights } from '../../store/modules/AppInsights'
@Component({
    data:() => {
        return {
            hideRuleContent: []
        }
    }
})
export default class Notifications extends Vue {
    headerHeight: string = '';
    @Prop({required: true}) readonly toggleStatus!: boolean;
    public firstClick: boolean = false;
    private hideArray: string = '';

    constructor() {
        super(); 
         bus.$on("notificationchanged",(msg) => {
                 this.getAllNotification();
                 this.$notify({
                    group: "Notification",
                    title: "Alert",
                    text: msg,
                });           
            }); 
            
        bus.$on("shiftTradenotificationchanged",() => {
                 this.getAllNotification();         
            });
    }

    @profile.State 
    public profileData!: any;
    @notification.State public notificationList!: any;
    async created() {
        this.getAllNotification();
    }

    @Watch('toggleStatus', {immediate: true}) onMatchChanged() {
        if(this.toggleStatus) {
            const topHeight = document.getElementsByClassName('neu-nav neu-topnav--compact')[0] as HTMLElement;
            this.headerHeight = topHeight.offsetHeight + 'px';
            this.firstClick = true;
            document.body.classList.add('fixed', 'w-100');
        } else {
            document.body.classList.remove('fixed', 'w-100');
        }
    }

    get customTop() {
        let style = '';
        if(!this.toggleStatus) {
            style = 'height:1px;';
        }
        if(this.firstClick) {
            return style+= `top:${this.headerHeight}`
        } else {
            return style;
        }
    }

    async getAllNotification() {
        await this.$store.dispatch("notification/getAllNotifications", this.profileData.username);

        this.updateNotificationCount();
    }

    GetShiftTradeOffer(actionableByDate, shiftTradeOfferId) {
        bus.$emit("loadShiftTradeEvent", actionableByDate, shiftTradeOfferId);
        this.closeNav();
    }    

    ShiftTradeOfferAction(actionableByDate, action, notificationId, shiftTradeOfferId) {
        bus.$emit('ShiftTradeActionEvent', actionableByDate, action, shiftTradeOfferId, notificationId);
        this.closeNav();
    }

    closeNav(){
        try{
            this.hideArray = '';
            this.toogleHideRule({},'', '');
            this.updateNotificationCount();
            this.$emit('close-event');
        } catch(e) {console.log(e)}
    }

    updateNotificationCount() {
        try{
            if(!this.notificationList){return}
            const notificaionUnreadCount = this.notificationList.reduce((obj: any, v: any) => {
                obj[v.read] = (obj[v.read] || 0) + 1;
                return obj;
            }, {});

            this.$emit('unreadNotification', {count: (notificaionUnreadCount.false || 0), totalCount: this.notificationList.length});
        } catch(e) {console.log(e)}
    }
    async deleteNotification(event:any, notificationId: string) {
        event.stopPropagation();
        console.log('deleteNotification:', notificationId);
        await this.$store
            .dispatch("notification/deleteNotification", notificationId);
        this.updateNotificationCount();       
    }
    toogleHideRule(notification:any, index: string, key: string): void{
        try{
            const notificationStatus = notification.read;
            if(index === this.hideArray){
                this.hideArray = '';
                return;
            } else {
                this.notificationList = this.notificationList.map((list) => {
                    list.timestampVal = moment(list.timestamp).format('MMM D, yy - h:mm A');
                    if(index === list.id) {
                        list.read = true;
                    }
                    return list;
                });
                if(!notificationStatus) {
                    const allNotifications = this.notificationList;
                    notification.read = true;
                    this.readMessage(notification,allNotifications);
                }
                this.hideArray= index;
                this.updateNotificationCount();
            }
        } catch(e){console.log(e)}
    }

    readMessage(notificationData:object, notificationList: any) {
        this.$store.dispatch('notification/statusUpdate', {data: notificationData, list:notificationList});
    }
}
